// ── Starter crew types for Settings → Trenching → Production (Ryan, Oct 28 2026) ──────
// Ryan's four trench crews, from small urban work up to duct banks. "Crew types" on the
// Production list adds the ticked ones as ordinary setups (editable like any other).
// Each machine is matched to the Equipment list by name (first pattern that finds an
// in-service machine wins) so its day rate fills in; no match → the label at $0/day.
// Sizes and feet a day other than the small trench are first guesses — change them.
// No trucks or dump trailers on a crew (Ryan, Oct 28 2026): hauling is paid by the bid
// Trenching window's trucking per load, so a crew truck would be charged twice. The
// drivers stay in the crew's people — they're on the job all day.

export const CREW_TYPES = [
  {
    name: 'Small urban trench — 301 mini',
    width_in: 12, depth_in: 24, ft_per_day: 50,
    notes: 'Urban / tight work. 301 mini, three guys. Hauling (dump trailer) is priced in the Trenching window.',
    equipment: [
      { label: 'CAT 301 mini excavator', find: [/\b301(\.\d+)?\b/i] },
    ],
    labor: [{ role: 'Operator', people: 1 }, { role: 'Laborer', people: 2 }],
  },
  {
    name: 'Crossings — 305/306 + Bobcat',
    width_in: 18, depth_in: 36, ft_per_day: 40,
    notes: 'Road / driveway crossings. 305 or 306 mini, Bobcat. Hauling (5-yard dump) is priced in the Trenching window.',
    equipment: [
      { label: 'CAT 305 / 306 mini excavator', find: [/\b305\b/i, /\b306\b/i, /\b306-/i] },
      { label: 'Bobcat', find: [/bobcat s\d+/i, /skid ?steer/i, /bobcat loader/i] },
    ],
    labor: [{ role: 'Operator', people: 2 }, { role: 'Laborer', people: 1 }],
  },
  {
    name: 'NV Energy trench — excavator',
    width_in: 24, depth_in: 48, ft_per_day: 300,
    notes: 'NV Energy joint trench. Excavator, four guys counting the 10-wheeler driver. Hauling is priced in the Trenching window.',
    equipment: [
      { label: 'Excavator', find: [/kx0?80/i, /excavator 080/i, /\b315\b/i] },
    ],
    labor: [{ role: 'Operator', people: 2 }, { role: 'Laborer', people: 2 }],
  },
  {
    name: 'Duct bank (3 ft+) — big Takeuchi + loader',
    width_in: 36, depth_in: 60, ft_per_day: 150,
    notes: 'Duct banks 3 ft wide and up. Big Takeuchi, loader, six guys counting the end dump driver. Hauling is priced in the Trenching window.',
    equipment: [
      { label: 'Takeuchi TB2150 excavator', find: [/tb2150/i, /takeuchi tb/i, /takeuchi/i] },
      { label: 'Loader', find: [/938/i, /914/i, /wheel loader/i, /\bloader\b/i] },
    ],
    labor: [{ role: 'Operator', people: 3 }, { role: 'Laborer', people: 3 }],
  },
];

// The in-service machine a crew line points at, or null.
export function matchEquipment(line, equipment) {
  const live = (equipment || []).filter(q => !/retired|sold/i.test(q.status || '') && !q.rental_returned_at);
  for (const re of line.find || []) {
    const q = live.find(x => re.test([x.asset_number, x.name, x.make, x.model].filter(Boolean).join(' ')));
    if (q) return q;
  }
  return null;
}
